const {registerModule, KitModule} = window;

class Locations extends KitModule {
  constructor($element) {
    super($element);

    this.bindEvents();
  }

  bindEvents() {
    this.$locationItem.forEach(($location) => {
      $location.addEventListener('mouseenter', this);
      $location.addEventListener('click', this);
    });
  }

  onmouseenter(e) {
    const index = e.currentTarget.getAttribute('data-index');
    const visibleMedia = this.$element.querySelector(`.js-location-media[data-index="${index}"]`);
    visibleMedia.classList.add('is-active');
    this.$locationMedia.forEach(($media) => {
      if ($media != visibleMedia && $media != this.$locationMedia[0]) {
        $media.classList.remove('is-active');
      }
    });
  }

  onclick(e) {
    e.currentTarget.classList.toggle('is-expanded');
  }
}

registerModule('Locations', Locations);
